module.exports = __webpack_public_path__ + "img/logo-generali.10cf9521.svg";